import react, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../../helpers/Toast";
import { SettingsListDTO } from "../../models/Settings/SettingsListDTO";
import { SettingsService } from "../../services/SettingsService";
import { SettingEditDTO } from "../../models/Settings/SettingsEditDTO";
import Layout from "../../components/Layout/Layout";
import { IoArrowBackSharp } from "react-icons/io5";
import { FormattedMessage, useIntl } from "react-intl";
import { CircularProgress } from "@mui/material";
import { Col, Row } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import ButtonComponent from "../../components/ButtonComponent";

export function SettingsEdit() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const intl = useIntl();
  const service = new SettingsService();
  const [setting, setSetting] = useState<SettingsListDTO>(
    {} as SettingsListDTO
  );
  const [loading, setLoading] = useState<boolean>(false);

  const getById = async () => {
    setLoading(true);
    const response = await service.GetById(Number(id));
    if (response.success === false || response.obj === null) {
      setLoading(false);
      Toast.Show("error", response.message);
      return;
    }

    setSetting(response.obj);
    setLoading(false);
  };

  const edit = async () => {
    var data: SettingEditDTO = {
      id: Number(id),
      value: setting.value,
    };

    setLoading(true);
    const response = await service.Edit(data);
    if (response.success === false) {
      setLoading(false);
      Toast.Show("error", response.message);
      return;
    }
    setLoading(false);
    navigate(-1);
    Toast.Show("success", "Setting editado com sucesso");
  };

  useEffect(() => {
    getById();
  }, []);

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <span className="pageTitle">
            {" "}
            <IoArrowBackSharp
              className="pageTitleBackIcon"
              onClick={() => navigate(-1)}
            />
            <FormattedMessage id="Screens.Settings.Title" />:
          </span>
        </div>
        <div className="pageBody">
          {loading === true && (
            <div className="loading">
              <span>
                {" "}
                <FormattedMessage id="Common.Loading.DataLoading" />
                ...{" "}
              </span>
              <CircularProgress style={{ marginLeft: "10px" }} size={"25px"} />
            </div>
          )}

          {loading === false && setting === null && (
            <div style={{ color: "#E74C3C" }}>
              <FormattedMessage id="Screens.User.UserDontExist" />
            </div>
          )}

          {loading === false && setting !== null && (
            <>
              <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                  xl={3}
                  lg={4}
                  md={5}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"text"}
                  value={setting.name}
                  label={intl.formatMessage({
                    id: "Screens.Settings.Info.Name",
                  })}
                  readOnly={true}
                />
                <InputComponent
                  xl={4}
                  lg={4}
                  md={5}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"text"}
                  value={setting.value}
                  label={intl.formatMessage({
                    id: "Screens.Settings.Info.Value",
                  })}
                  readOnly={loading}
                  onChange={(t: string) => setSetting({ ...setting, value: t })}
                />
              </Row>
              <Row style={{ margin: "0px", padding: "0px" }}>
                <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                  <ButtonComponent
                    style={{ width: "100%", marginTop: "10px" }}
                    text={intl.formatMessage({ id: "SettingsEdit.Save" })}
                    loading={loading}
                    onClick={() => edit()}
                  />
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
